import { useEffect } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { createSelector } from 'reselect';
import _ from 'lodash';

import BreadCrumb from '../../../Components/Common/BreadCrumb';
import OrderDetailTable from './components/OrderDetails';

import GeneralInfo from './components/GeneralInfo';
import CashbackInfo from './components/CashbackInfo';
import { getOrderById } from '../../../slices/orders/thunk';

const OrderManagementDetails = (props) => {
  const dispatch = useDispatch();
  const { orderId } = useParams();

  useEffect(() => {
    dispatch(getOrderById(orderId));
  }, [dispatch, orderId]);

  const ticket = useSelector(
    createSelector(
      (store) => store.Order,
      (slice) => slice?.order?.ticket ?? '',
    ),
  );

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={`${props.t('sale')} ${ticket}`} pageTitle={props.t('orders')} showBackButton />
        </Container>

        <Row className="w-100 mx-auto gx-4 gx-md-5">
          <Col xl={3} className="order-2 order-xl-1 mt-5 mt-xl-0">
            <GeneralInfo />
          </Col>

          <Col xl={9} className="order-1 order-xl-2">
            <CashbackInfo />
            <OrderDetailTable />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default withTranslation()(OrderManagementDetails);
